import { clsx } from 'clsx'

import { CheckIcon, Typography } from 'components'

type Step = {
	number: number
	completed: boolean
	current: boolean
}

type Props = {
	steps: Step[]
}

const Stepper = ({ steps }: Props) => (
	<div class='flex w-full items-center'>
		{steps.map((step, index) => (
			<div
				class={clsx('flex items-center', {
					'w-full': index < steps.length - 1
				})}
				key={step.number}
			>
				{/* Step Box */}
				<div
					class={clsx(
						'flex h-8 w-14 items-center justify-center gap-1 rounded-md border',
						!step.completed && !step.current
							? 'border-black-100'
							: 'border-green-500'
					)}
				>
					{step.completed ? (
						<div class='relative flex h-3.5 w-3.5 items-center justify-center rounded-full bg-product'>
							<CheckIcon className='text-black-900' height='8' width='10' />
						</div>
					) : (
						<div
							class={clsx(
								'h-3 w-3 rounded-full border',
								!step.completed && !step.current
									? 'border-black-100'
									: 'border-product'
							)}
						/>
					)}
					<Typography
						color={clsx(
							step.completed || step.current
								? 'text-green-500'
								: 'text-black-100'
						)}
						text={`0${step.number}`}
						variant='text3'
					/>
				</div>

				{/* Dynamic Connecting Line */}
				{index < steps.length - 1 && (
					<div
						class={clsx(
							'flex-1 border-t',
							step.completed || step.current
								? 'border-green-500'
								: 'border-black-100'
						)}
					/>
				)}
			</div>
		))}
	</div>
)

export { Stepper }
